import { Tooltip } from "@xola/ui-kit";
import { useError } from "common";
import React, { ReactNode, useState } from "react";

interface ErrorTooltipProps {
    children: ReactNode;
    label?: string;
    name: string;
}

export const ErrorTooltip = ({ label, name, children }: ErrorTooltipProps) => {
    const error = useError(name);
    const [visible, setVisible] = useState(true);

    // Show the tooltip automatically the first time,
    // but go back to hover mode after user clicks outside of it
    const props = error ? (visible ? { visible } : { trigger: "mouseenter" }) : { visible: false };

    return (
        <Tooltip
            {...props}
            content={label ? `${label} ${error}` : error}
            onClickOutside={() => {
                setVisible(!visible);
            }}
        >
            {children}
        </Tooltip>
    );
};
